import { AppLink } from '@/shared/components/AppLink';
import type { PlpBreadcrumbItem } from '../../utils/plpBreadcrumb';

export function PlpBreadcrumb({ items }: { items: PlpBreadcrumbItem[] }) {
  if (items.length === 0) return null;

  return (
    <nav aria-label="Breadcrumb" className="text-[11px] font-normal uppercase tracking-wider text-gray-500 md:text-xs">
      <ol className="flex flex-wrap items-center gap-x-1 gap-y-1">
        {items.map((item, index) => (
          <li key={`${item.label}-${index}`} className="inline-flex items-center gap-x-1">
            {index > 0 ? (
              <span className="px-1 text-gray-400" aria-hidden>
                /
              </span>
            ) : null}
            {item.to ? (
              <AppLink to={item.to} shouldRefresh={item.shouldRefresh ?? false} className="hover:text-gray-700">
                {item.label}
              </AppLink>
            ) : (
              <span className="text-gray-600">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
